import React from 'react'
import { DATA_TEST_ID } from 'shared-constants/build/testIds'
import {
  useCmsArticlePageBySlug,
  prepareGetStaticPropsForArticlePage,
} from '@public/CmsPage/ArticlePage'
import { getPublicLayout } from '@public/components/PublicLayout'
import { Box } from 'components/Layout'
import { LOADER_SIZE } from 'components/Loader'
import { PureSSRIndicator } from 'components/PureSSRIndicator'
import { Seo } from 'components/Seo'
import { WidgetsWrapper } from 'components/Widgets'
import { PAGE_MIN_HEIGHT, WrappedLoader } from 'components/WrappedLoader'
import { BLOG_PAGE_SLUG } from 'constants/common'
import { getSeoPropsForCmsPage } from './CmsPage/getSeoPropsForCmsPage'

export const Blog = () => {
  const { pageBySlug, widgets, isLoading } = useCmsArticlePageBySlug({
    slug: BLOG_PAGE_SLUG,
  })

  if (isLoading) {
    return (
      <WrappedLoader
        loaderSize={LOADER_SIZE.XXXL}
        minHeight={PAGE_MIN_HEIGHT}
      />
    )
  }
  const seoProps = {
    ...getSeoPropsForCmsPage(pageBySlug, {
      fallbackMetaTitle:
        'Home Design Inspiration + Advice - The Expert Stories',
      fallbackDescription:
        "Get inspired by the world's best interior designers, read their free advice on the best paint colors, decor trends, lighting tricks and more on The Expert's blog.",
    }),
  }
  return (
    <>
      <Seo {...seoProps} />
      <Box data-test-id={DATA_TEST_ID.BLOG}>
        <WidgetsWrapper widgets={widgets} slug={BLOG_PAGE_SLUG} />
        <PureSSRIndicator />
      </Box>
    </>
  )
}

export function getStaticProps(context) {
  return prepareGetStaticPropsForArticlePage(context, { slug: BLOG_PAGE_SLUG })
}

const PageLayout = (page) => getPublicLayout(page, { isWithBreadcrumbs: true })
Blog.getLayout = PageLayout
